import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { ApiHelper } from '../../helpers/apihelper'
import * as Constants from '../../helpers/constants'
import AppConfigContext from '../app_layout/app_config_context'

import PlanCard from '../products/component/cards/plan_cards'
import AddonCard from '../products/component/cards/addon_card'
import ProductUsersContainer from './index'

const PlanInfo = () => {
  const { planId } = useParams()
  const { client } = useContext(AppConfigContext)
  const crmUser = useSelector(state => state.user)
  const [product, setProduct] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (!client || !planId) return
    setIsLoading(true)
    const getUserProduct = ApiHelper(client, 'GET_PRODUCT')
    const query = _.pick(
      {
        product_id: planId,
        client_secret: Constants.CLIENT_SECRET,
        crm_user_data: JSON.stringify({ name: crmUser.name, user_id: crmUser.id })
      },
      getUserProduct.API_QUERY
    )
    getUserProduct.API(client, query)
      .then(res => {
        if (res?.status === Constants.CO_API.SUCCESS) {
          setProduct(res.data.data.product || null)
        }
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => setIsLoading(false))
  }, [client, planId, crmUser])
  if (isLoading || !product) return null
  const isPlan = product.type === Constants.PRODUCT_TYPE.plan
  // clearoutphone has no plan/info endpoint, so the attached-users panel is clearout-only.
  const supportsPlanUsers = Boolean(client && ApiHelper(client, 'PLAN_INFO'))
  const getProductCard = () => {
    if (isPlan)
      return <PlanCard product={product} />
    return <AddonCard product={product} />
  }
  const getProductLayout = () => {
    if (isPlan) {
      return (
        <>
          <div className={supportsPlanUsers ? 'col-md-3' : 'col-md-4 mx-auto'}>
            {getProductCard()}
          </div>
          {supportsPlanUsers && (
            <div className="col-md-9">
              <ProductUsersContainer
                planId={planId}
                product={product}
              />
            </div>
          )}
        </>
      )
    }
    return (
      <div className="col-12 d-flex flex-column align-items-center">
        <div className="plan-info-addon-card-wrapper mb-4">
          {getProductCard()}
        </div>
        {supportsPlanUsers && (
          <div className="plan-info-users-wrapper">
            <ProductUsersContainer
              planId={planId}
              product={product}
            />
          </div>
        )}
      </div>
    )
  }
  return (
    <div className="container-fluid">
      <div className="row">
        {getProductLayout()}
      </div>
    </div>
  )
}

export default PlanInfo